const printButtons = document.querySelectorAll(".button--print") as NodeListOf<HTMLInputElement>;

printButtons.forEach((button) => {
    button.addEventListener("click", () => {
        window.print();
    });
});